exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-input__slot[data-v-2dfa136e] {\n  top: 9px !important;\n}\n", ""]);

// exports
